import { notification } from 'doraemon';
import { pagePrivileges } from 'src/services/user';
import {
  addDepPosition,
  batchSwitchStatus,
  deletePositionInfo,
  fetchDeleteEmployeeList,
  getDepartmentList,
  getOrganizationOperators,
  getOrganizationOperatorsDesensitization,
  getPersonDetail,
  getPersonDetailDesensitization,
  modifyInfo,
  modifyPositionInfo,
  operatorOrder,
  setCanSwitch,
  switchStatus,
} from '../services';

export default {
  namespace: 'employee',
  state: {
    actionType: 'add',
    userInfo: {},
    tableInfo: {
      data: [],
      page: 0,
      size: 0,
      total: 0,
      totalPage: 0,
    },
    deleteEmployeeInfo: {
      data: [],
      page: 0,
      size: 0,
      total: 0,
      totalPage: 0,
    },
    expandedKeysList: null,
    defaultSelectedKeys: [],
    employeeParams: {},
    selectedDepNode: [],
  },
  effects: {
    *getOrganizationOperators({ payload }, { call, put }) {
      try {
        const res = yield call(getOrganizationOperators, payload);
        yield put({
          type: 'setState',
          payload: {
            tableInfo: res.result || [],
            employeeParams: payload,
          },
        });
      } catch (e) {
        notification.error({
          message: '部门人员获取失败',
        });
        throw e;
      }
    },
    // 脱敏
    *getOrganizationOperatorsDesensitization({ payload }, { call, put }) {
      try {
        const res = yield call(getOrganizationOperatorsDesensitization, payload);
        yield put({
          type: 'setState',
          payload: {
            tableInfo: res.result || [],
            employeeParams: payload,
          },
        });
      } catch (e) {
        notification.error({
          message: '部门人员获取失败',
        });
        throw e;
      }
    },

    // 获取删除人员列表
    *getList({ payload }, { call, put }) {
      try {
        const res = yield call(fetchDeleteEmployeeList, payload);
        yield put({
          type: 'setState',
          payload: {
            deleteEmployeeInfo: res || {},
          },
        });
      } catch (e) {
        notification.error({
          message: '人员列表获取失败',
        });
        throw e;
      }
    },

    // 恢复删除人员
    *recoverUser({ payload }, { call }) {
      const result = yield call(setCanSwitch, payload);
      return result;
    },

    // 前端页面资源鉴权查询
    *pagePrivileges({ payload }, { call }) {
      const result = yield call(pagePrivileges, payload);
      return result;
    },

    // 获取人员详情
    *GetPersonDetail({ payload }, { call }) {
      return yield call(getPersonDetail, payload);
    },
    // 获取人员详情-脱敏
    *GetPersonDetailDesensitization({ payload }, { call }) {
      return yield call(getPersonDetailDesensitization, payload);
    },

    // 修改人员的部GetPersonDetail门任职信息
    *ModifyInfo({ payload }, { call }) {
      return yield call(modifyInfo, payload);
    },

    // 起停用
    *SwitchStatus({ payload }, { call }) {
      return yield call(switchStatus, payload);
    },

    // 获取成员的任职信息列表
    *GetDepartmentList({ payload }, { call }) {
      return yield call(getDepartmentList, payload);
    },

    // 修改人员的部门任职信息
    *ModifyPositionInfo({ payload }, { call }) {
      return yield call(modifyPositionInfo, payload);
    },

    // 删除人员的部门任职信息
    *DeletePositionInfo({ payload }, { call }) {
      return yield call(deletePositionInfo, payload);
    },

    // 新建一个职位
    *AddDepPosition({ payload }, { call }) {
      return yield call(addDepPosition, payload);
    },

    // 批量修改操作人状态
    *batchSwitchStatus({ payload }, { call }) {
      return yield call(batchSwitchStatus, payload);
    },

    // 批量修改操作人状态
    *operatorOrder({ payload }, { call }) {
      return yield call(operatorOrder, payload);
    },
  },
  reducers: {
    setState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
